// HUD Eligibility Universe Code as stored on units and HUD contracts (AffordableFunding).
export const ELIGIBILITY_UNIVERSE_CODE_ENUM = {
  PRE_1981: 'PRE_1981',
  POST_1981: 'POST_1981',
};
